module.exports = new __parcel__URL__("favicon.8f76876f.svg").toString();